import { Col, Menu, Row, Tooltip } from 'antd'
import Avatar from 'components/Avatar'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import ExportTransfer from '../../../../components/ExportTransfer'
import {
  ActionButton,
  ActionButtonDanger,
  ActionButtonWithIcon,
  CompanyTitle,
  GroupText,
  InfoHeader,
  JobPosition,
  RoundedCircle,
  TextWithIcon,
} from '../../style'
import { RightSection } from '../../../Placement/style'
import Export from 'components/Export'
import CsvImage from '../../../../components/icons/csv-image.svg'
import GoogleSheetImage from '../../../../components/icons/google-sheet.svg'
import XlsxImage from '../../../../components/icons/xlsx-image.svg'
import { CustomizeMenu, CustomSpin } from '../../../JobRoles/PageHeader/style'
import { useSelector } from 'react-redux'
import Cancel from '../../../../assets/icons/Cancel'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import ShortlistIcon from '../../../../components/icons/Shortlist'
import Reopen from '../../../../assets/icons/Reopen'
import Complete from '../../../../assets/icons/Complete'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Button from '../../../../components/Button'
import ArchiveIcon from '../../../../components/icons/ArchiveIcon'
import { archiveRole, unarchiveRole } from '../../../RolePage/actions'
const InformationHeader = ({
  previewData,
  handleViewEvaluationClick,
  isLoading,
  getOneRoleExports,
  onHandleClose,
  onHandleComplete,
  singleRoleData,
  handleNavigate,
}) => {
  const params = useParams()
  const [showRoleDrawer, setShowRoleDrawer] = useState(false)
  const [showCompletePopup, setShowCompletePopup] = useState(false)
  const [showArchiveDrawer, setShowArchiveDrawer] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  console.log('InformationHeader previewData:', previewData)
  console.log('InformationHeader singleRoleData:', singleRoleData)
  console.log('InformationHeader params:', params)    
  
  // Use previewData since singleRoleData is undefined
  const roleData = singleRoleData || previewData
  console.log('Using roleData:', roleData)

  const showConfirm = () => {
    setShowRoleDrawer(true)
  }
  const showCompleteConfirm = () => {
    setShowCompletePopup(true)
  }

  const [exportLoading, setExportLoading] = useState(false)
  const metricsData = useSelector(state => state?.jobRolesPreview?.metricsData)

  const handleDriveExportClick = async type => {
    setExportLoading(true)
    try {
      let payload = {
        roleId: params.roleId,
        downloadType: '',
      }
      if (type === 'xlsx') {
        try {
          payload.downloadType = 'xlsx'
          const blob = await getOneRoleExports(payload)
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `RoleWise Drive Report.xlsx`)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)

          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else if (type === 'googlesheet') {
        try {
          payload.downloadType = 'googlesheet'
          const response = await getOneRoleExports(payload)
          window.open(response.data.url, '_blank')
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else {
        try {
          payload.downloadType = 'csv'
          const blob = await getOneRoleExports(payload)
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `RoleWise Drive Report.csv`)

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          handleTransferClick(false)

          setExportLoading(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const [exportOpen, setExportOpen] = useState(false)
  const menuItem = [
    {
      label: 'XLSX',
      type: 'xlsx',
      image: XlsxImage,
    },
    {
      label: 'Google Sheet',
      type: 'googlesheet',
      image: GoogleSheetImage,
    },
    {
      label: 'CSV',
      type: 'csv',
      image: CsvImage,
    },
  ]
  const isDisabled = metricsData?.applied === 0

  const exportMenu = (
    <CustomizeMenu>
      {exportLoading ? (
        <Menu.Item key="loading">
          <CustomSpin tip="Loading" size="medium" />
        </Menu.Item>
      ) : (
        <>
          {menuItem.map((item, index) => {
            return (
              <Menu.Item
                key={index + 'menuItem'}
                icon={<img src={item.image} />}        
                disabled={isDisabled}
                onClick={() => handleDriveExportClick(item.type)}
              >
                {item.label}
              </Menu.Item>
            )
          })}
        </>
      )}
    </CustomizeMenu>
  )
  const handleExportOpen = () => {
    setExportLoading(false)
    setExportOpen(true)
  }
  const companyId = previewData?.companyId
  return (
    <>
      <InfoHeader>
        <Row>
          <Col md={12} xs={12}>
            <TextWithIcon>
              {!isLoading ? (
                previewData?.company?.logo?.url ? (
                  <RoundedCircle>
                    <img
                      src={previewData?.company?.logo?.url}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                      alt=""
                    />
                  </RoundedCircle>
                ) : (
                  <Avatar
                    background
                    size={42}
                    IconName={
                      previewData?.company?.companyName?.split('')?.[0] ||
                      previewData?.tittle?.split('')?.[0]
                    }
                    font={18}
                  />
                )
              ) : null}
              <GroupText direction="column">
                {previewData?.rolePublishedBy === 'INSTITUTE' ? (
                  <CompanyTitle>
                    {previewData?.company?.companyName}
                  </CompanyTitle>
                ) : (
                  <>
                    <CompanyTitle>{previewData?.corporate?.name}</CompanyTitle>
                    <JobPosition>
                      {previewData?.corporate?.industry}
                    </JobPosition>
                  </>
                )}
              </GroupText>
            </TextWithIcon>
          </Col>
          <Col md={12} xs={12}>
            {!isLoading && (
              <TextWithIcon justify={'end'}>
                <Button.Secondary
                  height={'38px'}
                  text="View Evaluation Process"
                  onClick={handleNavigate}
                  disabled={!previewData?.driveRoleMap?.length > 0 && !previewData?.generalTallyFormUrl}
                />
                <RightSection centerVertically>
                  <Export
                    label="View Drive Report"
                    overlayMenu={exportMenu}
                    open={exportOpen}
                    setOpen={setExportOpen}
                    onOpenChange={handleExportOpen}
                    exportLoading={exportLoading}
                    buttonDisabled={isDisabled}
                    isViewDriveReport={true}
                  />
                </RightSection>
                {/* Archive / Unarchive — eligible only when no students have applied (canArchive from API). */}
                {roleData?.isArchived ? (
                  <Tooltip title="Restore this role">
                    <span
                      onClick={() => setShowArchiveDrawer(true)}
                      style={{
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '8px',
                      }}
                    >
                      <ArchiveIcon color="rgba(50, 73, 215, 1)" />
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={
                      roleData?.canArchive
                        ? 'Archive this role'
                        : "Can't archive — students have already applied"
                    }
                  >
                    <span
                      onClick={() => {
                        if (roleData?.canArchive) setShowArchiveDrawer(true)
                      }}
                      style={{
                        cursor: roleData?.canArchive ? 'pointer' : 'not-allowed',
                        opacity: roleData?.canArchive ? 1 : 0.4,
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '8px',
                      }}
                    >
                      <ArchiveIcon />
                    </span>
                  </Tooltip>
                )}
                {
                  previewData?.interviewWorkFlow?.rounds?.length > 0 &&
                  previewData?.roleStatus !=
                    'COMPLETED' &&
                  previewData?.roleStatus !=
                    'ROLE_CLOSED' &&
                  previewData?.roleStatus !=
                    'DRAFT' && (
                    <ActionButtonWithIcon
                      text={'Mark as complete'}
                      onClick={showCompleteConfirm}
                      color="secondary"
                      fontColor="#fff"
                      icon={<Complete />}
                      bgColor="#5DB594"
                    />
                  )}
                {
                  !previewData?.isArchived &&
                  previewData?.roleStatus !==
                    'DRAFT' &&
                  (previewData?.roleStatus !==
                    'ROLE_CLOSED' &&
                  previewData?.roleStatus !==
                    'COMPLETED' ? (
                    <ActionButtonDanger
                      text={'Cancel Role'}
                      icon={<Cancel />}
                      onClick={showConfirm}
                      color="danger"
                      type="danger"
                      // disabled={!companyId}
                    />
                  ) : (
                    <ActionButtonWithIcon
                      text={'Re-Open Role'}
                      icon={<Reopen />}
                      onClick={showConfirm}
                      color="primary"
                      type="primary"
                      // disabled={!companyId}
                    />
                  ))}
              </TextWithIcon>
            )}
          </Col>
        </Row>
      </InfoHeader>
      {showRoleDrawer && (
        <CloseRoleDrawer
          description={
            <>
              Do you want to{' '}
              {previewData?.roleStatus ===
                'ROLE_CLOSED' ||
              previewData?.roleStatus === 'COMPLETED'
                ? ' reopen this role?'
                : ' cancel this role?'}
            </>
          }
          Icon={ShortlistIcon}
          showDrawer={showRoleDrawer}
          setShowDrawer={setShowRoleDrawer}
          onApprove={onHandleClose}
          onCloseClick={() => {
            setShowRoleDrawer(false)
          }}
        />
      )}
      {showCompletePopup && (
        <CloseRoleDrawer
          description={<>Do you want to complete this role?</>}
          Icon={ShortlistIcon}
          showDrawer={showCompletePopup}
          setShowDrawer={setShowCompletePopup}
          onApprove={onHandleComplete}
          onCloseClick={() => {
            setShowCompletePopup(false)
          }}
        />
      )}
      {showArchiveDrawer && (
        <CloseRoleDrawer
          description={
            roleData?.isArchived
              ? 'Restore this role? It will be moved back into the active Roles list and Dashboard.'
              : 'Archive this role? It will be hidden from the Roles list, Dashboard, and exports. You can restore it from the Archive tab.'
          }
          Icon={ShortlistIcon}
          showDrawer={showArchiveDrawer}
          setShowDrawer={setShowArchiveDrawer}
          onApprove={async () => {
            try {
              if (roleData?.isArchived) {
                await dispatch(unarchiveRole(params.roleId || roleData?.id))
                setShowArchiveDrawer(false)
                // Restored role belongs back in the active list; the current
                // preview page is showing stale isArchived=true data.
                navigate('/rolePage')
              } else {
                await dispatch(archiveRole(params.roleId || roleData?.id))
                setShowArchiveDrawer(false)
                // After archive, the role is hidden from default views — send the user back.
                navigate('/rolePage')
              }
            } catch (err) {
              setShowArchiveDrawer(false)
            }
          }}
          onCloseClick={() => {
            setShowArchiveDrawer(false)
          }}
        />
      )}
    </>
  )
}

export default InformationHeader
